import { Injectable } from '@angular/core';
import { STORAGE_KEYS } from '../constants/app.constants';
import { SessionStorageService } from '../services/session-storage.service';
import { normalizeUtcDateTimeString } from './session-time.util';

export type RouteMode = 'workbench' | 'inspection';

export interface RouteModeLock {
  mode: RouteMode;
  updatedAt: string;
}

@Injectable({ providedIn: 'root' })
export class RouteModeLockStore {
  constructor(private readonly storage: SessionStorageService) {}

  get snapshot(): RouteModeLock | null {
    const stored = this.storage.getItem<RouteModeLock>(STORAGE_KEYS.ROUTE_MODE_LOCK);
    return this.normalizeLock(stored);
  }

  setMode(mode: RouteMode): void {
    this.storage.setItem(STORAGE_KEYS.ROUTE_MODE_LOCK, {
      mode,
      updatedAt: new Date().toISOString(),
    } satisfies RouteModeLock);
  }

  clear(): void {
    this.storage.removeItem(STORAGE_KEYS.ROUTE_MODE_LOCK);
  }

  isInspectionLocked(): boolean {
    return this.snapshot?.mode === 'inspection';
  }

  private normalizeLock(lock: RouteModeLock | null): RouteModeLock | null {
    if (!lock || (lock.mode !== 'workbench' && lock.mode !== 'inspection')) {
      return null;
    }

    const normalizedUpdatedAt = normalizeUtcDateTimeString(lock.updatedAt);
    if (!normalizedUpdatedAt) {
      return null;
    }

    return {
      mode: lock.mode,
      updatedAt: normalizedUpdatedAt,
    };
  }
}
